// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"5390929f","645":"93fdff3b"}[chunkId] + ".chunk.css";
};